import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=28519ccb&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=28519ccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28519ccb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28519ccb')) {
      api.createRecord('28519ccb', component.options)
    } else {
      api.reload('28519ccb', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=28519ccb&scoped=true&", function () {
      api.rerender('28519ccb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4dIZo30Cy2dfL/JS/comp/CookieBox.vue"
export default component.exports